// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CheckboxButton__wrapper___3jZ03","main":"CheckboxButton__main___4yb3N","active":"CheckboxButton__active___3h9u8"};